export default "__VITE_ASSET__COJRACJj__"